import { Banca, Materia, Questao, Resolucao, Usuario } from "../@types";
import { Anexo } from "../@types/Anexo";
import { TagDto } from "../@types/TagDto";
import Service from "./Service";

type TagsByContextRequest = {
  testingAgencyId?: string;
  subjectId?: string;
  testingAgencyIds?: string[];
  subjectIds?: string[];
  answerStatus?: string;
};

class QuestaoService extends Service {
  static getQuestoes() {
    return this.Http.get<Questao.Questao[]>("/questions").then(this.getData);
  }

  static getTestingAgencies() {
    return this.Http.get<Banca.Banca[]>("/testingagencies").then(this.getData);
  }

  static getTestingAgenciesBySubscriber() {
    return this.Http.get<Banca.Banca[]>("/testingagencies/allbysubscriber").then(
      this.getData,
    );
  }

  static getSubjects() {
    return this.Http.get<Materia.Materia[]>("/subjects").then(this.getData);
  }

  static getSubjectsBySubscriber() {
    return this.Http.get<Materia.Materia[]>("/subjects/allbysubscriber").then(
      this.getData,
    );
  }

  static getTagsByContext(body: TagsByContextRequest) {
    return this.Http.post<TagDto.TagDto[]>("/questions/tags/by-context", body).then(this.getData);
  }

  static getTagsByContextSubscriber(body: TagsByContextRequest) {
    return this.Http.post<TagDto.TagDto[]>(
      "/questions/tags/by-context-subscriber",
      body,
    ).then(this.getData);
  }

  static buscarTagBancaAnoMateria() {
    return this.Http.get<TagDto.TagDto[]>("/questions/tagsfromsubjects").then(this.getData);
  }

  static buscarTagsDasPalavrasChaves() {
    return this.Http.get<TagDto.TagDto[]>("/questions/tags").then(this.getData);
  }

  static getQuestoesAleatorias(
    banca: Banca.Banca,
    dificuldade: "DIFICIL" | "FACIL" | "MEDIO",
    materia: Materia.Materia
  ) {
    let criterio = ``;

    criterio += banca ? `?banca=${banca.id}` : ``;
    criterio += criterio.length > 0 ? `&` : ``;
    criterio += dificuldade ? `dificuldade=${dificuldade}` : ``;
    criterio += criterio.length > 0 ? `&` : ``;
    criterio += materia ? `materia=${materia.id}` : ``;

    return this.Http.get<Questao.Questao[]>(
      `/resolucaoQuestao/buscarQuestaoAleatoria` + criterio
    ).then(this.getData);
  }

  static getQuestaoAleatoriaPendenteOuNaoResolvida(queryString: String, usuario: Usuario.Usuario) {
    let criterio = ``;

    criterio += queryString ? `palavrasChaves=${queryString}` : ``;
    criterio += criterio.length > 0 ? `&` : ``;
    criterio += `usuario=${usuario.id}`;

    return this.Http.get<Resolucao.ResolucaoQuestao[]>(
      `/questions/random`
    ).then(this.getData);
  }

  static getQuestoesPaginadas(query: Questao.QuestionFilterQuery) {
    return this.Http.post<Questao.PaginatedResult>("/questions/allpaginated", query).then(this.getData);
  }

  static getQuestoesPorFiltro(query: Questao.QuestionFilterByQuery) {
    return this.Http.post<Questao.Questao[]>("/questions/allbyfilter", query).then(this.getData);
  }

  static getQuestao(id: number | string) {
    return this.Http.get<Questao.Questao>(`/questions/${id}`).then(this.getData);
  }

  static inserirNovaQuestao(questao: Questao.Questao) {
    return this.Http.post<Questao.Questao>("/questions", questao).then(this.getData);
  }

  static atualizarQuestao(questao: Questao.Questao) {
    return this.Http.put<Questao.Questao>(`/questions/${questao.id}`, questao).then(this.getData);
  }

  // Persiste só o anexo, sem o replace completo do PUT /questions/:id —
  // string vazia remove a imagem.
  static setQuestaoAttachment(id: string, attachment: string) {
    return this.Http.put<Questao.Questao>(`/questions/${id}/attachment`, { attachment }).then(
      this.getData,
    );
  }

 static setQuestaoDisabled(id: string, disabled: boolean) {
  return this.Http.put(
    `/questions/${id}/disabled`,
    { disabled },
    { headers: { "Content-Type": "application/json" } }
  ).then(this.getData);
}


  static uploadAnexo(file: File) {
    const formData = new FormData();
    formData.append("anexo", file);

    return this.Http.post<Anexo.Anexo>("/questions/anexo", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then(this.getData)
      .catch((error) => {
        console.log(error);
      });
  }
}

export default QuestaoService;
